import React from 'react';
import '@/styles/custom.css';

export const NewsletterMailIcon = ({ width = 49, height = 57 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 49 57"
      fill="none"
    >
      <path
        d="M42.8001 1.03491L6.2001 15.9149C2.8451 17.1549 0.100098 21.4949 0.100098 25.2149V52.1849C0.100098 55.9049 2.8451 57.7649 6.2001 56.5249L42.8001 41.6449C46.1551 40.4049 48.9001 36.0649 48.9001 32.3449V5.37491C48.9001 1.65491 46.1551 -0.205088 42.8001 1.03491ZM44.6301 9.09491L26.3301 37.9249L5.8951 23.9749C5.5901 23.6649 4.6751 22.7349 5.2851 21.8049C5.8951 20.5649 7.4201 21.1849 7.4201 21.1849L26.6351 28.3149C26.6351 28.3149 41.2751 8.78491 42.1901 7.54491C42.4951 6.92491 43.4101 6.61491 44.3251 7.23491C45.2401 7.85491 44.9351 8.78491 44.6301 9.09491Z"
        fill="#05F273"
      />
    </svg>
  );
};
